import Vue from 'vue'

$(document).ready(() => {
  $('.viewings-search-hide-past-viewings').on('change', event => {
    if (event.target.checked) {
      $('.viewings-search-start-at-from').prop('disabled', true)
      $('.viewings-search-end-at-to').prop('disabled', true)
    } else {
      $('.viewings-search-start-at-from').prop('disabled', false)
      $('.viewings-search-end-at-to').prop('disabled', false)
    }
  })

  $('.viewing-info-card .mailer-trigger').on('click', event => {
    const el = event.target
    Vue.$modal.email({
      mailType: el.dataset.mailType,
      path: el.dataset.path,
      to: el.dataset.to,
      replyTo: el.dataset.replyTo,
      subject: el.dataset.subject,
      body: el.dataset.body,
      callback: () => {
        M.toast({ html: 'メールを送信しました' })
        $('.auto-replied-chip').remove()
        $('.manual-replied-chip').removeClass('hide')
      },
    })
  })
})
